import {
  type HealthMissionCategoryName,
  HeartIcon,
  type IconUrl,
  MicroscopeIcon,
  SyringeIcon,
} from "@pharmupp/p3-front-commons"

export const HealthMissionCategoryIcon: Record<HealthMissionCategoryName, IconUrl> =
  {
    VACCINATION: SyringeIcon,
    SCREENING: MicroscopeIcon,
    SUPPORT: HeartIcon,
  }
